import { EnumBase } from 'hay-core-react';
class PesquisaExecucaoLogStatusEnum extends EnumBase {
    constructor() {
        super(
            [
                'main.pesquisaexecucaolog.status.emexecucao',
                'main.pesquisaexecucaolog.status.sucesso',
                'main.pesquisaexecucaolog.status.erro',
            ],
            'main.pesquisaexecucaolog.status.emexecucao'
        );
    }
}

const instance = new PesquisaExecucaoLogStatusEnum();
export default instance;
